export default {
  stories: {
    type: 'fade',
    arrows: false,
    pagination: true,
    cover: true,
    autoplay: true,
    interval: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    rewind: true,
    classes: {
      pagination: 'splide__pagination stories-slider__pagination',
      page: 'splide__pagination__page stories-slider__slide-bullet',
    },
  },
  quotes: {
    display: {
      type: 'fade',
      pagination: false,
      arrows: false,
      cover: true,
    },
    controls: {
      updateOnMove: true,
      type: 'loop',
      pagination: false,
      arrows: false,
      fixedWidth: 200,
      fixedHeight: 96,
      height: 96,
      gap: 48,
      cover: true,
      isNavigation: true,
      focus: 'center',
      drag: true,
      breakpoints: {
        720: {
          fixedWidth: 152,
          fixedHeight: 56,
          height: 56,
          gap: 32,
        },
      },
    },
  },
};
